import { render, staticRenderFns } from "./UserGroupManager.vue?vue&type=template&id=3f74db06&scoped=true&"
import script from "./UserGroupManager.vue?vue&type=script&lang=js&"
export * from "./UserGroupManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f74db06",
  null
  
)

export default component.exports